import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { cn } from '@workspace/utils';

export interface GarantieItem {
  code: string;
  nom: string;
  active: boolean;
  /** Ouvre le détail de la garantie (picto info à côté du libellé). */
  onInfo?: () => void;
}

interface GarantiesListProps {
  garanties: GarantieItem[];
  className?: string;
  /** Rendu sur fond foncé (carte sélectionnée). */
  inverse?: boolean;
}

export const GarantiesList = ({ garanties, className, inverse = false }: GarantiesListProps) => (
  <ul className={cn('space-y-2 sm:space-y-3', className)}>
    {garanties.map((garantie) => (
      <li key={garantie.code} className="flex items-start gap-2">
        {garantie.active ? (
          <CheckIcon className={cn('w-4 h-4 mt-0.5 flex-shrink-0', inverse ? 'text-white' : 'text-success')} />
        ) : (
          <XMarkIcon className={cn('w-4 h-4 mt-0.5 flex-shrink-0', inverse ? 'text-white/70' : 'text-neutral-400')} />
        )}
        <span
          className={cn(
            'text-xs',
            !garantie.active && (inverse ? 'text-white/70 line-through' : 'text-neutral-500 line-through'),
          )}
        >
          {garantie.nom}
        </span>
        {garantie.onInfo && (
          <button
            type="button"
            aria-label={`En savoir plus : ${garantie.nom}`}
            className={cn('ml-auto shrink-0 cursor-pointer', inverse ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-primary')}
            onClick={(e) => {
              // why: la carte entière sélectionne la formule au clic
              e.stopPropagation();
              garantie.onInfo?.();
            }}
          >
            <InformationCircleIcon className="h-4 w-4" />
          </button>
        )}
      </li>
    ))}
  </ul>
);
